export default {
  syncProviderStatus: 'Sync Status from Provider',
} as const;
